exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-user-form .user-list{margin-top:.75rem}.select-user-form .user-list .user{margin-bottom:.75rem}.select-user-form .user-list .user:last-child{margin-bottom:0}", ""]);

// exports
